"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typingHeader_vue_1 = require("./typingHeader.vue");
exports.default = typingHeader_vue_1.default;
